import { cn } from "@/lib/utils";

function Toggle({ className, ...props }: React.ComponentProps<"input">){
    return (
        <label className="relative flex justify-between items-center p-2 text-l">
            {props.title}
            <input type="checkbox" className={cn("absolute left-0 top-0 w-full h-full appearance-none peer rounded-md", className)} />
            <span className="w-9 h-6 flex items-center flex-shrink-0 ml-4 p-1 bg-gray-300 rounded-full duration-300 ease-in-out peer-checked:bg-green-400 after:w-4 after:h-3 after:bg-white after:rounded-full after:shadow-md after:duration-300 peer-checked:after:translate-x-3"></span>
        </label>
    );
}

function ToggleLabel({ className, ...props }: React.ComponentProps<"label">){
    return (
        <label className={cn("relative flex justify-between items-center p-2 text-l", className)} {...props}/>
    )
}

function ToggleInput({ className, ...props }: React.ComponentProps<"input">){
    return (
        <input type="checkbox" data-slot="input" className={cn("absolute left-0 top-0 w-full h-full appearance-none peer rounded-md", className)} {...props} />
    )
}

function ToggleSpan({ className, ...props }: React.ComponentProps<"span">){
    return (
        <span className={cn("w-9 h-6 flex items-center flex-shrink-0 ml-4 p-1 bg-gray-300 rounded-full duration-300 ease-in-out peer-checked:bg-green-400 after:w-4 after:h-3 after:bg-white after:rounded-full after:shadow-md after:duration-300 peer-checked:after:translate-x-3", className)} {...props}/>
    )
}

export {
    Toggle,
    ToggleLabel,
    ToggleInput,
    ToggleSpan
}